import { AlertStatus } from 'uplisting-frontend/models/schemas';
import NotificationsUplistingBaseRoute from 'uplisting-frontend/pods/notifications/uplisting/base-route';

export default class NotificationsUplistingPendingRoute extends NotificationsUplistingBaseRoute {
  alertStatus = AlertStatus.pending;
}
